var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<button ng-if=\"vm.async\" ng-class=\"[vm.btnCls, vm.buttonClass]\" ng-click=\"vm.downloadAsyncCsv()\" ng-disabled=\"vm.btnDisabled\"><i ng-if=\"vm.btn\" ng-class=\"[vm.btnIcon, vm.buttonClass]\" class=\"glyphicon\"></i><span>{{ vm.btnLabel }}</span></button><a ng-if=\"!vm.async\" ng-class=\"vm.btnCls\" ng-href=\"vm.CsvDownload.getCsvLink(vm.baseUrl, vm.urlParams)\" target=\"_self\" ng-disabled=\"vm.btnDisabled\"><i ng-if=\"vm.btn\" ng-class=\"vm.btnIcon\" class=\"glyphicon\"></i><span>{{ vm.btnLabel }}</span></a>");;return buf.join("");
}